// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DeleteColumnOutlinedSvg from "@fishx/icons-svg/es/asn/DeleteColumnOutlined";
import FishxIcon from '../components/FishxIcon';

var DeleteColumnOutlined = function DeleteColumnOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DeleteColumnOutlinedSvg
  }));
};

DeleteColumnOutlined.displayName = 'DeleteColumnOutlined';
export default React.forwardRef(DeleteColumnOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DeleteColumnOutlined.js
// module id = 2383
// module chunks = 0